import { useMutation, useQueryClient } from '@tanstack/react-query'
import type {
  UpdateStatusByFilterQueryDto,
  UpdateStatusByFilterResponseDto,
} from '../../../api/dto/plan-benefit-override-rules.dto'
import { PlanBenefitOverrideRuleStatus } from '../enums/plan-benefit-override-rule.enum'
import { updateStatusByFilter } from '../../../api/plan-benefit-override-rules-api'
import { OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanBenefitOverride/hooks/useGetOverrideRules'

interface UpdateStatusByFilterVariables {
  query: UpdateStatusByFilterQueryDto
  targetStatus: PlanBenefitOverrideRuleStatus
}

export function useUpdateStatusByFilter() {
  const queryClient = useQueryClient()

  return useMutation<
    UpdateStatusByFilterResponseDto,
    unknown,
    UpdateStatusByFilterVariables
  >({
    mutationFn: ({ query, targetStatus }) =>
      updateStatusByFilter(query, { status: targetStatus }),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [OVERRIDE_RULES_QUERY_KEY] })
    },
  })
}
